import { render } from "./OrderPreparationProduct.vue?vue&type=template&id=20cbc704"
import script from "./OrderPreparationProduct.vue?vue&type=script&lang=js"
export * from "./OrderPreparationProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__